var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from "react";

function IconZestimate(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    d: "M6.776 15.816c-.059.03-.106.022-.153-.023l-1.306-1.517c-.034-.043-.039-.066.008-.13 1.01-1.44 3.069-3.687 4.382-4.635.023-.016.015-.035-.012-.023-1.368.434-5.257 2.066-6.695 2.859V17.5h13.996v-4.963c-1.907.316-7.621 1.975-10.22 3.279zm5.69-9.271c.07-.015.102.007.145.053a69.95 69.95 0 011.227 1.437c.039.046.012.096-.02.122-1.563 1.19-3.302 2.874-4.272 4.079-.019.027-.003.027.012.023 1.689-.71 5.655-1.842 7.442-2.158V7.894L10.008 2.5 3.004 7.89v2.413c2.17-1.257 7.188-3.206 9.462-3.758z"
  }));
}

export default IconZestimate;